import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaTelegram } from "react-icons/fa";
import { SiX, SiTiktok } from "react-icons/si";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-dark text-light py-3">
      <Container>
        <Row className="align-items-center">
          <Col md={4}>
            <h6 className="mb-0">Designed and Developed by ZMedia</h6>
          </Col>
          <Col md={4} className="text-center">
            <small className="mb-0">Copyright © {year} FoldedFifth</small>
          </Col>
          <Col md={4} className="text-end">
            <ul className="list-inline mb-0">
              <li className="list-inline-item">
                <a
                  href="https://x.com/FontanaEcoTem"
                  className="text-light"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit Fontana on X (formerly Twitter)"
                >
                  <SiX aria-hidden="true" />
                </a>
              </li>
              <li className="list-inline-item ms-3">
                <a
                  href="https://t.me/FontanaEcosystem"
                  className="text-light"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Open Fontana Telegram group"
                >
                  <FaTelegram aria-hidden="true" />
                </a>
              </li>
              <li className="list-inline-item ms-3">
                <a
                  href="https://www.tiktok.com/@fontanaecosystem"
                  className="text-light"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit Fontana on TikTok"
                >
                  <SiTiktok aria-hidden="true" />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
